export { default as Chip } from './Chip'
export { ChipVariant } from './types'
export type { ChipProps, ChipVariantType } from './types'
